export const INDEX = "/";
export const HOME = "home";
export const ABOUT = "about";
export const BLOG = "blog";
export const CONTACT_US = "contact-us";
export const SERVICES = "services";
export const GMB = "google-my-business";
export const INITIATIVE = "one-kb-initiative";
export const BOOKING_PAGE = "era-tek-kb-booking";
export const ONE_KB_INITIATIVE = "eratek-1kb-initiative";
export const ERA_TEK_DISCOVERY = "eratek-discovery-call";
export const TALENT_REQUISITION_FORM = "talent-requisition-form";
export const WILD_CARD ="*"
